import close from './close';

export default function closeOrLess(a, b, tolerance) {
    return a < b || close(a, b, tolerance);
}


//////////////////
// WEBPACK FOOTER
// C:/spro/Workspaces/VisualCode/Ecoltex2/node_modules/@progress/kendo-drawing/dist/es/geometry/math/close-or-less.js
// module id = ../../../../@progress/kendo-drawing/dist/es/geometry/math/close-or-less.js
// module chunks = vendor